import { useQuery } from '@tanstack/react-query';
import { execute, executeGraphql } from '../graphql/execute';
import { RootQuery } from '../graphql/generated/graphql';
import { GetPage } from '../graphql/queries/pagebuilder';

export const usePage = (uri: string, isPreview: boolean = false) => {
  return useQuery({
    queryKey: ['page', uri, isPreview ? 'graphql' : 'json'],

    queryFn: async () => {
      if (isPreview) {
        return executeGraphql(GetPage, { uri });
      } else {
        return execute<RootQuery>(uri);
      }
    },
    enabled: !!uri,
    retry: 0,
    staleTime: isPreview ? 0 : 1000 * 60 * 5, // cache the page on live for 5 minutes in browser
    refetchOnWindowFocus: isPreview,
  });
};
